import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_2 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 2,
  class: "alert alert-info"
}
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_8 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_10 = ["id", "value", "disabled"]
const _hoisted_11 = ["for"]
const _hoisted_12 = {
  key: 0,
  class: "fw-semibold me-1"
}
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = {
  key: 1,
  class: "badge bg-light text-dark border ms-1"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["id", "value", "disabled"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 2,
  class: "badge bg-light text-dark border ms-1"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}

import { ref, watch } from "vue";
import BaseModal from "../../../../room-booking-management/calendar/components/BaseModal.vue";
import { fetchBookableAppointments, bookAppointment } from "../api";


export default {
  __name: 'AppointmentBookingModal',
  props: {
	show: { type: Boolean, default: false },
	apiUrl: { type: String, required: true },
},
  emits: ["close", "booked"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref(false);
const saving = ref(false);
const error = ref("");
// { conflictingDates: string[] } | null — blocking room/booking conflicts.
const conflict = ref(null);
// Dates outside opening hours — a non-blocking hint; the user can still confirm the booking.
const closedDates = ref([]);

const series = ref([]);
const appointments = ref([]);
// "s<id>" for a series, "a<id>" for a standalone appointment
const selected = ref("");

function reset() {
	error.value = "";
	conflict.value = null;
	closedDates.value = [];
	series.value = [];
	appointments.value = [];
	selected.value = "";
}

function formatDate(isoDate) {
	const parts = String(isoDate).split("-");
	return parts.length === 3 ? `${parts[2]}.${parts[1]}.${parts[0]}` : isoDate;
}

async function load() {
	loading.value = true;
	try {
		const result = await fetchBookableAppointments(props.apiUrl);
		series.value = result.series || [];
		appointments.value = result.appointments || [];
	} catch (e) {
		error.value = e.message;
	} finally {
		loading.value = false;
	}
}

async function confirmBooking() {
	if (!selected.value) {
		return;
	}
	// A second "Buchen" click after the opening-hours hint confirms the booking anyway.
	const ignoreOpeningHours = closedDates.value.length > 0;
	const id = Number(selected.value.slice(1));
	const payload = selected.value.startsWith("s") ? { seriesId: id } : { appointmentId: id };
	if (ignoreOpeningHours) {
		payload.ignoreOpeningHours = true;
	}

	saving.value = true;
	error.value = "";
	conflict.value = null;
	closedDates.value = [];
	try {
		await bookAppointment(props.apiUrl, payload);
		emit("booked");
	} catch (e) {
		saving.value = false;
		const response = e.response || {};
		if (response.conflict) {
			// Real room/booking conflict — blocks the booking.
			conflict.value = { conflictingDates: response.conflictingDates || [] };
		} else if (response.closed) {
			// Only outside opening hours — surface as a hint and let the user confirm.
			closedDates.value = response.closedDates || [];
		} else {
			error.value = e.message;
		}
	}
}

// Switching the selected appointment clears prior warnings, so each selection goes through its own
// "first click warns, second click confirms" flow for the opening-hours hint.
watch(selected, () => {
	error.value = "";
	conflict.value = null;
	closedDates.value = [];
});

watch(
	() => props.show,
	(isShowing) => {
		if (isShowing) {
			reset();
			load();
		}
	}
);

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    title: "Terminbuchung – Termin auswählen",
    size: "lg",
    "modal-id": "appointmentBookingModal",
    "is-loading": saving.value,
    onClose: _cache[4] || (_cache[4] = $event => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(error.value), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (conflict.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-1" }, [
              _createElementVNode("i", { class: "fas fa-triangle-exclamation me-2" }),
              _createTextVNode(" Die Buchung kann nicht durchgeführt werden: ")
            ], -1 /* CACHED */)),
            _createElementVNode("ul", _hoisted_3, [
              (conflict.value.conflictingDates.length)
                ? (_openBlock(), _createElementBlock("li", _hoisted_4, " Bereits belegt am: " + _toDisplayString(conflict.value.conflictingDates.map(formatDate).join(", ")), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mb-0 mt-2 small" }, " Bitte passe Raum oder Zeit in der Planung an und versuche es erneut. ", -1 /* CACHED */))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Outside opening hours is only a hint: clicking \"Buchen\" again confirms the booking. "),
      (closedDates.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mb-1" }, [
              _createElementVNode("i", { class: "fas fa-circle-info me-2" }),
              _createTextVNode(" Folgende Termine liegen außerhalb der Öffnungszeiten: ")
            ], -1 /* CACHED */)),
            _createElementVNode("p", _hoisted_6, _toDisplayString(closedDates.value.map(formatDate).join(", ")), 1 /* TEXT */),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-0 small" }, " Klicke erneut auf „Buchen\", um die Buchung trotzdem durchzuführen. ", -1 /* CACHED */))
          ]))
        : _createCommentVNode("v-if", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fas fa-spinner fa-spin me-2" }, null, -1 /* CACHED */),
            _createTextVNode("Lädt … ", -1 /* CACHED */)
          ]))]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            (series.value.length === 0 && appointments.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Es gibt keine planbaren Termine, die noch gebucht werden können. "))
              : _createCommentVNode("v-if", true),
            (series.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[11] || (_cache[11] = _createElementVNode("h6", { class: "mb-2" }, " Terminreihen ", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(series.value, (entry) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 's' + entry.id,
                      class: "form-check"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        id: 'tb-series-' + entry.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selected).value = $event)),
                        class: "form-check-input",
                        type: "radio",
                        value: 's' + entry.id,
                        disabled: !entry.bookable
                      }, null, 8 /* PROPS */, _hoisted_10), [
                        [_vModelRadio, selected.value]
                      ]),
                      _createElementVNode("label", {
                        for: 'tb-series-' + entry.id,
                        class: _normalizeClass(["form-check-label", { 'text-muted': !entry.bookable }])
                      }, [
                        (entry.number)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "#" + _toDisplayString(entry.number), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("strong", null, _toDisplayString(entry.scheduleText || 'Terminreihe'), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_13, [
                          _createTextVNode(" · " + _toDisplayString(entry.count) + " Termine · " + _toDisplayString(entry.timeText) + " Uhr · " + _toDisplayString(entry.roomLabel) + " ", 1 /* TEXT */),
                          (entry.employeeName)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString(entry.employeeName), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          (entry.bookingType)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" · " + _toDisplayString(entry.bookingType), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (!entry.bookable)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "kein Raum"))
                          : _createCommentVNode("v-if", true)
                      ], 10 /* CLASS, PROPS */, _hoisted_11)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            (appointments.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "mb-2" }, " Einzeltermine ", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointments.value, (entry) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'a' + entry.id,
                      class: "form-check"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        id: 'tb-appointment-' + entry.id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selected).value = $event)),
                        class: "form-check-input",
                        type: "radio",
                        value: 'a' + entry.id,
                        disabled: !entry.bookable
                      }, null, 8 /* PROPS */, _hoisted_16), [
                        [_vModelRadio, selected.value]
                      ]),
                      _createElementVNode("label", {
                        for: 'tb-appointment-' + entry.id,
                        class: _normalizeClass(["form-check-label", { 'text-muted': !entry.bookable }])
                      }, [
                        _createTextVNode(_toDisplayString(entry.dateText) + " · " + _toDisplayString(entry.timeText) + " Uhr · " + _toDisplayString(entry.roomLabel) + " ", 1 /* TEXT */),
                        (entry.employeeName)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" · " + _toDisplayString(entry.employeeName), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (entry.bookingType)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" · " + _toDisplayString(entry.bookingType), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (!entry.bookable)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "kein Raum"))
                          : _createCommentVNode("v-if", true)
                      ], 10 /* CLASS, PROPS */, _hoisted_17)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: saving.value,
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
      }, " Abbrechen ", 8 /* PROPS */, _hoisted_19),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: saving.value || !selected.value,
        onClick: _cache[3] || (_cache[3] = $event => (confirmBooking()))
      }, [
        (saving.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21))
          : _createCommentVNode("v-if", true),
        _cache[13] || (_cache[13] = _createTextVNode(" Buchen ", -1 /* CACHED */))
      ], 8 /* PROPS */, _hoisted_20)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "is-loading"]))
}
}

}